<div
    #contextmenu
    id="contextmenu"
    [class]="theme"
    [ngStyle]="{ visibility: visible ? 'visible' : 'hidden', top: posY + 'px', left: posX + 'px' }"
>
    <ul id="menulist">
        @for (menuItem of menu; track menuItem) {
            @if (!menuItem.visible || menuItem.visible()) {
                <!-- MENUITEM -->
                @if (!menuItem.divider && !menuItem.subMenu) {
                    <li
                        [class]="
                            !menuItem.enabled || menuItem.enabled() ? 'actionitem' : 'disabled-item'
                        "
                        (click)="
                            (!menuItem.enabled || menuItem.enabled()) &&
                                menuItem.click &&
                                menuItem.click()
                        "
                        (focus)="mouseOverItem()"
                        (mouseover)="mouseOverItem()"
                    >
                        @if (menuItem.icon) {
                            <i class="actionicon {{ menuItem.icon }}" aria-hidden="true"></i>
                        }
                        <span class="actiontext">{{ menuItem.text }}</span>
                        @if (menuItem.shortcut) {
                            <span class="actionshortcut">{{ menuItem.shortcut.getString() }}</span>
                        }
                    </li>
                }
                <!-- SUBMENU -->
                @if (menuItem.subMenu) {
                    <li
                        [class]="
                            !menuItem.enabled || menuItem.enabled() ? 'actionitem' : 'disabled-item'
                        "
                        (click)="stopPropagation($event)"
                        (focus)="
                            (!menuItem.enabled || menuItem.enabled()) &&
                                mouseoverSubMenu($event, menuItem)
                        "
                        (mouseover)="
                            (!menuItem.enabled || menuItem.enabled()) &&
                                mouseoverSubMenu($event, menuItem)
                        "
                    >
                        <span class="actiontext">{{ menuItem.text }}</span>
                        <i class="submenuicon fa fa-caret-right" aria-hidden="true"></i>
                    </li>
                }
                @if (menuItem.divider) {
                    <hr />
                }
            }
        }
    </ul>
</div>

<ng-template #submenu></ng-template>
